import Paper from "@mui/material/Paper";
import { isMobile } from "react-device-detect";
import TabPanel from "../../../components/carousel/TabPanel";
import MarketsPage from "../../proposicao/Proposicao.Mercados"


const GerUsuariosCarouselTabsMercados = (props: { id_user: number, activeTab: any, index: number, onChange?: () => void, id_permissao?: number }) => {

    return (

        <Paper style={{ borderRadius: "6px", marginTop: `${isMobile ? "0px" : props.id_permissao != 4 ? "-30px" : "0px"}` }}>
            <TabPanel value={props.activeTab} index={props.index}>
                <MarketsPage id_user={props.id_user} index={props.index} activeTab={props.activeTab} onChange={props.onChange} id_permissao={props.id_permissao} />
            </TabPanel>
        </Paper>

    )
}

export default GerUsuariosCarouselTabsMercados;